import React, { useEffect, useState } from "react";
import api, { describeError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

const blank = { new_date: "", new_time: "", reason: "", notes: "" };

export default function AdjournDialog({ open, onOpenChange, hearing, onSaved }) {
  const [form, setForm] = useState(blank);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) setForm(blank); }, [open]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    if (!form.new_date || !form.reason) { toast.error("New date and reason are required"); return; }
    setSaving(true);
    try {
      await api.post(`/hearings/${hearing.id}/adjourn`, form);
      toast.success("Hearing adjourned");
      onSaved?.();
      onOpenChange(false);
    } catch (err) { toast.error(describeError(err, "Could not adjourn the hearing.")); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-navy">Adjourn Hearing</DialogTitle>
          <DialogDescription>The current hearing is marked Adjourned and a new hearing is scheduled.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1.5"><Label className="text-xs text-muted-foreground">New Hearing Date *</Label><Input type="date" data-testid="adjourn-date-input" value={form.new_date} onChange={set("new_date")} /></div>
            <div className="space-y-1.5"><Label className="text-xs text-muted-foreground">New Hearing Time</Label><Input type="time" value={form.new_time} onChange={set("new_time")} /></div>
          </div>
          <div className="space-y-1.5"><Label className="text-xs text-muted-foreground">Reason for Adjournment *</Label><Input data-testid="adjourn-reason-input" value={form.reason} onChange={set("reason")} placeholder="e.g. Judge on leave / matter not reached" /></div>
          <div className="space-y-1.5"><Label className="text-xs text-muted-foreground">Notes</Label><Textarea value={form.notes} onChange={set("notes")} rows={2} /></div>
        </div>
        <DialogFooter><Button onClick={save} disabled={saving} data-testid="adjourn-save-btn" className="bg-navy text-white hover:bg-navy-light">{saving ? "Saving…" : "Adjourn Hearing"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
